import { useNavigate } from "react-router-dom";
import { Building2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PATHS } from "@/lib/router";
import { useTran } from "@/hooks";

const ConsolidatedEmptyState = () => {
  const { t } = useTran();
  const navigate = useNavigate();

  return (
    <div className="rounded-lg border border-dashed border-border bg-muted/20 p-10 text-center">
      <Building2 className="mx-auto mb-3 h-10 w-10 text-muted-foreground" />
      <h3 className="text-base font-semibold text-foreground">
        {t("No metrics assigned yet")}
      </h3>
      <p className="mt-1 max-w-md mx-auto text-sm text-muted-foreground">
        {t(
          "Set up Master Data Assignment to roll up values across your organization.",
        )}
      </p>
      <Button
        className="mt-4"
        size="sm"
        onClick={() => navigate(PATHS.ESG_MASTER_DATA_ASSIGN)}
      >
        {t("Go to Master Data Assignment")}
      </Button>
    </div>
  );
};

export default ConsolidatedEmptyState;
